import { trim } from 'lodash';
import { useEffect } from 'react';
import { useState } from 'react';
import useDebounce from './useDebounce';

const useSearchInput = (initialValue = '') => {
  const [searchInput, setSearchInput] = useState(initialValue);
  const [search, setSearch] = useState(initialValue);

  useEffect(() => {
    setSearch(trim(searchInput));
  }, [searchInput]);

  return {
    searchInput,
    setSearchInput,
    search: useDebounce(search, 300),
  };
};

export default useSearchInput;
